<template>
  <AppMainDialogForm
    v-model="dialog"
    :isLoading="isLoading"
    size="700"
    :tituloTela="tituloTela"
    :tooltip="tooltip"
    @initComponent="initComponent"
    @saveRegistro="saveRegistro"
    @cancel="cancel"
  >
    <v-form v-model="isFormValid" ref="form">
      <v-container fluid :key="componentKey">
        <v-row class="ma-0">
          <v-col cols="6">
            <v-autocomplete
              :rules="[campoSelectObrigatorio]"
              v-model="registro.csTipoUnidadeExploracao"
              :items="tiposUnidadesExploracao"
              clearable
              color="primary"
              item-text="dsTipoUnidadeExploracao"
              item-value="csTipoUnidadeExploracao"
              label="Tipo"
              outlined
            >
            </v-autocomplete>
          </v-col>
          <v-col cols="6">
            <v-text-field
              :rules="[campoObrigatorio]"
              v-model.trim="registro.nrUnidadeExploracao"
              label="Número"
              outlined
              clearable
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
              :rules="[campoObrigatorio, campoMaiorZero]"
              type="number"
              v-model.number="registro.qtCapacidadeAlojamento"
              label="Capacidade de Alojamento"
              outlined
              clearable
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
              type="number"
              v-model.number="registro.nrMossa"
              label="Número Mossa"
              outlined
              clearable
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-autocomplete
              v-model="registro.lstCdTipoBebedouro"
              label="Tipos de bebedouro"
              outlined
              clearable
              :items="drinkingFountainTypes"
              item-text="nmTipoBebedouro"
              item-value="idTipoBebedouro"
              multiple
            />
          </v-col>
          <v-col cols="6">
            <v-autocomplete
              v-model="registro.lstCdTipoComedouro"
              label="Tipos de comedouro"
              outlined
              clearable
              :items="feederTypes"
              item-text="nmTipoComedouro"
              item-value="idTipoComedouro"
              multiple
            />
          </v-col>
          <v-col cols="6">
            <v-autocomplete
              v-model="registro.lstCdTipoPiso"
              label="Tipos de piso"
              outlined
              clearable
              :items="floorTypes"
              item-text="nmTipoPiso"
              item-value="idTipoPiso"
              multiple
            />
          </v-col>
        </v-row>
        <v-row v-if="!isInserting" class="ma-0 p-relative">
          <v-col cols="12" class="pa-0">
            <v-row align="center" class="ma-0">
              <v-subheader class="grey--text subtitle-1 font-weight-bold">
                Silos
              </v-subheader>
              <v-spacer />
              <v-btn icon @click="onAddSiloClick">
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </v-row>
          </v-col>
          <v-col cols="12">
            <v-row
              align="center"
              v-for="(silo, idx) in registro.silos"
              :key="idx"
            >
              <v-col cols="6">
                <v-text-field
                  outlined
                  label="Nome"
                  v-model="silo.nmSilo"
                  v-only-number
                  hide-details
                />
              </v-col>
              <v-col cols="5">
                <v-text-field
                  outlined
                  label="Capacidade"
                  v-model="silo.qtCapacidadeSilo"
                  v-only-number
                  hide-details
                />
              </v-col>
              <v-col cols="1">
                <v-btn icon @click="deleteSilo(silo, idx)">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
  </AppMainDialogForm>
</template>

<script>
import {
  campoObrigatorio,
  campoMaiorZero,
  campoSelectObrigatorio
} from "@/filters/rules";

import AppMainDialogForm from "@/components/layout/AppMainDialogForm.vue";

export default {
  components: {
    AppMainDialogForm
  },
  computed: {
    tiposUnidadesExploracao() {
      return this.$store.state.tiposUnidadesExploracao;
    },
    urlAPIEstabelecimento() {
      return this.$store.state.urlAPIEstabelecimento;
    }
  },
  data() {
    return {
      tooltip: "Nova Unidade de Exploração Pecuária",
      tituloTela: "Cadastro de Unidade de Exploração Pecuária",
      isFormValid: true,
      isLoading: false,
      registro: {
        csTipoAnimal: "SU",
        lstCdTipoBebedouro: [],
        lstCdTipoComedouro: [],
        lstCdTipoPiso: [],
        silos: []
      },
      feederTypes: [],
      drinkingFountainTypes: [],
      floorTypes: [],
      isInserting: false,
      componentKey: 0,
      deletedSilos: []
    };
  },
  methods: {
    campoObrigatorio: campoObrigatorio,
    campoMaiorZero: campoMaiorZero,
    campoSelectObrigatorio: campoSelectObrigatorio,
    initComponent() {
      let context = this;
      context.deletedSilos = [];
      this.$emit("openDialog");
      if (this.rec.idUnidadeExploracao != undefined) {
        this.isInserting = false;
        context.$axios
          .get(
            context.urlAPIEstabelecimento +
              "silo/?cdUep=" +
              this.rec.idUnidadeExploracao
          )
          .then(response => {
            var records = response.data;
            if (records.length > 0) {
              this.rec.silos = records;
            }
          })
          .catch(error => {
            context.changeViewState("isError", error);
          });
      } else {
        if (this.$refs.form != undefined) {
          this.$refs.form.reset();
        }
        this.isInserting = true;
        this.registro = {
          nrUnidadeExploracao: "",
          qtCapacidadeAlojamento: "",
          csTipoUnidadeExploracao: ""
        };
      }

      this.registro = Object.assign({}, this.rec);
      if (this.rec) {
        this.registro.lstCdTipoPiso =
          this.rec.tipoPisos && this.rec.tipoPisos.map(i => i.idTipoPiso);
        this.registro.lstCdTipoComedouro =
          this.rec.tipoComedouros &&
          this.rec.tipoComedouros.map(i => i.idTipoComedouro);
        this.registro.lstCdTipoBebedouro =
          this.rec.tipoBebedouros &&
          this.rec.tipoBebedouros.map(i => i.idTipoBebedouro);
      }
    },
    saveRegistro() {
      if (this.$refs.form.validate()) {
        this.isLoading = true;
        if (this.isInserting) {
          this.insertRegistro();
        } else {
          this.updateRegistro();
        }
      }
    },
    insertRegistro() {
      this.registro.cdEstabelecimento = this.idEstabelecimento;
      this.registro.csTipoAnimal = "SU";
      this.registro.stAtivo = true;
      if (this.registro.nrMossa == "") {
        this.registro.nrMossa = null;
      }
      this.$axios
        .post(this.urlAPIEstabelecimento + "unidadeExploracao/", this.registro)
        .then(response => {
          this.$emit("inserted", response.data);
          this.$emit("closeDialog");
        })
        .catch(error => {
          this.$store.commit("setSnack", {
            type: "error",
            msg: error
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    updateRegistro() {
      if (this.registro.nrMossa == "") {
        this.registro.nrMossa = null;
      }
      this.$axios
        .put(
          this.urlAPIEstabelecimento +
            "unidadeExploracao/" +
            this.registro.idUnidadeExploracao,
          this.registro
        )
        .then(response => {
          this.$emit("updated", response.data);
          this.$emit("closeDialog");
          this.saveSilos(this.registro.silos);
          if (this.deletedSilos.length > 0) {
            this.actonDeleteSilos(this.deletedSilos);
          }
        })
        .catch(error => {
          this.$store.commit("setSnack", {
            type: "error",
            msg: error
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    actonDeleteSilos(listDeletedSilos) {
      let context = this;
      listDeletedSilos.forEach(function(silo) {
        context.$axios
          .delete(context.urlAPIEstabelecimento + "silo/" + silo.idSilo)
          .then(response => {
            context.$emit("updated", response.data);
          })
          .catch(error => {
            context.$store.commit("setSnack", {
              type: "error",
              msg: error
            });
          });
      });
    },
    saveSilos(listSilos) {
      let context = this;
      if (listSilos) {
        listSilos.forEach(function(silo) {
          if (silo.idSilo) {
            context.$axios
              .put(context.urlAPIEstabelecimento + "silo/" + silo.idSilo, silo)
              .then(response => {
                context.$emit("updated", response.data);
              })
              .catch(error => {
                context.$store.commit("setSnack", {
                  type: "error",
                  msg: error
                });
              });
          } else {
            context.$axios
              .post(context.urlAPIEstabelecimento + "silo/", silo)
              .then(response => {
                context.$emit("updated", response.data);
              })
              .catch(error => {
                context.$store.commit("setSnack", {
                  type: "error",
                  msg: error
                });
              });
          }
        });
      }
    },
    deleteSilo(silo, idx) {
      let item = this.registro.silos.find(x => x.idSilo == silo.idSilo);
      this.deletedSilos.push(item);
      this.registro.silos.splice(idx, 1);
    },
    cancel() {
      this.$emit("closeDialog");
    },
    loadTypesData() {
      this.$axios
        .get(this.urlAPIEstabelecimento + "tipoBebedouro/")
        .then(res => {
          const data = res.data;
          if (!data) return;

          this.drinkingFountainTypes = data;
        });

      this.$axios
        .get(this.urlAPIEstabelecimento + "tipoComedouro/")
        .then(res => {
          const data = res.data;
          if (!data) return;

          this.feederTypes = data;
        });

      this.$axios.get(this.urlAPIEstabelecimento + "tipoPiso/").then(res => {
        const data = res.data;
        if (!data) return;

        this.floorTypes = data;
      });
    },
    onAddSiloClick() {
      if (!this.registro.silos) this.registro.silos = [];
      this.registro.silos.push({
        idSilo: null,
        nmSilo: null,
        qtCapacidadeSilo: null,
        cdUep: this.rec.idUnidadeExploracao
      });
      this.forceRerender();
    },
    forceRerender() {
      this.componentKey += 1;
    }
  },
  props: {
    idEstabelecimento: Number,
    dialog: {
      type: Boolean,
      default: false
    },
    rec: {
      type: Object,
      default: () => ({})
    }
  },
  watch: {
    dialog(newValue, oldValue) {
      if (newValue && !oldValue) {
        this.initComponent();
      }
    }
  },
  mounted() {
    this.loadTypesData();
  }
};
</script>

<style scoped>
.item {
  margin: 1px;
}

.p-relative {
  position: relative !important;
}
</style>
